import { render, staticRenderFns } from "./HbChip.vue?vue&type=template&id=696a0eb7&scoped=true&"
import script from "./HbChip.vue?vue&type=script&lang=js&"
export * from "./HbChip.vue?vue&type=script&lang=js&"
import style0 from "./HbChip.vue?vue&type=style&index=0&id=696a0eb7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696a0eb7",
  null
  
)

export default component.exports